import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { DatasetActionContainerService } from 'app/main/components/dataset/services/dataset-action-container.service';
import { DatasetRecordService } from 'app/main/components/dataset/services/dataset-record.service';
import { AppService } from 'app/services/app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TripBookingPackageRelatedComponent } from '../trip-booking-packages-related.component';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
var TripBookingParticipantComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TripBookingParticipantComponent, _super);
    function TripBookingParticipantComponent(appService, datasetACS, datasetRS, datasetNavigatorService, matDialog, matDialogRef, data) {
        var _this = _super.call(this, appService, datasetACS, datasetRS, matDialogRef, data) || this;
        _this.appService = appService;
        _this.datasetACS = datasetACS;
        _this.datasetRS = datasetRS;
        _this.datasetNavigatorService = datasetNavigatorService;
        _this.matDialog = matDialog;
        _this.matDialogRef = matDialogRef;
        _this.data = data;
        return _this;
    }
    TripBookingParticipantComponent.prototype.onEdit = function () {
        var _this = this;
        this.datasetNavigatorService.openEditDialog(this.datasetACS, this.datasetRS.record.value)
            .afterClosed().subscribe(function (response) {
            _this.datasetRS.reloadWithParams({
                trip_booking_participant_id: _this.datasetRS.record.value.participant_id,
                trip_booking_package_id: _this.data.tripBookingPackageRS.recordId
            });
        });
    };
    TripBookingParticipantComponent.prototype.trash = function () {
        var _this = this;
        this.datasetNavigatorService.openDeleteDialog(this.datasetACS, this.datasetRS.record.value)
            .beforeClosed()
            .subscribe(function () {
            _this.datasetRS.record.next(null);
        });
    };
    return TripBookingParticipantComponent;
}(TripBookingPackageRelatedComponent));
export { TripBookingParticipantComponent };
